import MezzanineFloor from "./MezzanineFloor";
import GlassRailing from "./GlassRailing";
import GlassCurtain from "./GlassCurtain";
import Ceiling from "./Ceiling";
import PhysicsBoxes from "./PhysicsBoxes";
import MezzanineLights from "./MezzanineLights";

export default function Mezzanine() {
	return (
		<group>
			<PhysicsBoxes />
			<MezzanineFloor />
			<Ceiling />
			<GlassRailing />
			<GlassCurtain />
			<MezzanineLights />
		</group>
	);
}
